import React from 'react';

export default function SplashScreen() {
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-theme-light-page-bg dark:bg-theme-dark-page-bg">
      <div className="relative flex items-center justify-center">
        {/* Pink splash burst behind the logo */}
        <div
          aria-hidden
          className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none"
        >
          <div className="splash-pink-burst" />
        </div>
        {/* Jua logo with fast fade-in */}
        <img
          src="/assets/jua-logo.svg"
          alt="Jua"
          className="h-28 sm:h-32 md:h-40 lg:h-48 splash-logo-fade"
        />
      </div>
    </div>
  );
}
